var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-container',{attrs:{"grid-md":""}},[_c('v-layout',{staticStyle:{"display":"flex","flex-wrap":"wrap"}},[_c('v-flex',{attrs:{"md12":"","d-flex":""}},[_c('main',[_c('Login'),_c('OrDivider'),_c('SocialSignIn',{attrs:{"heading":'Sign in with social'}})],1)])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }